// eslint-disable-next-line eslint-comments/disable-enable-pair -- This is a bug and should be fixed!
/* eslint-disable prettier/prettier -- Bug or mismatch between eslint and prettier */
import ProductMeta from '@fogia/core-web/components/metadata/ProductMeta';
import { inServer } from '@fogia/core-web/constants';
import GetProductRelations from '@fogia/core-web/libs/GrebbCommerceAPI/Products/GetProductRelations';
import { getState, injectModels } from '@fogia/core-web/state';
import hideOverlays from '@fogia/core-web/state/models/Overlay/dispatches/hideOverlays';
import comparePriceToParent from '@fogia/core-web/utils/comparePriceToParent';
import getExternalId from '@fogia/core-web/utils/getExternalId';
import { isEmpty } from '@fogia/core-web/utils/object';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { withRouter } from 'react-router-dom';


const PRODUCTPAGERELATIONS = 'ADD CORE HERE'; // @TODO <---- fix this
const initialState = {
    isPackage: false,
    product: null,
    qtyBreaks: [],
    quantity: 1,
    productRelations: [],
    variantRelations: {},
    selectedProduct: null,
    selectedProductVariants: {},
    bestHistoricalPrice: {},
};

export const getFlag = (code, product = {}) => {
    const findFlag = (flag) => {
        if (Array.isArray(code)) {
            return code.some((c) => c.toLowerCase() === flag.code?.toLowerCase());
        }

        return flag.code?.toLowerCase() === code?.toLowerCase();
    };
    return (product?.format?.flags || []).find(findFlag) || false;
};

export const getParametric = (code, product = {}) => {
    const parametrics = product.parametrics || [];
    const variantParametrics = product.variantParametrics || [];

    const findParametric = (parametric) => {
        if (Array.isArray(code)) {
            return code.indexOf(parametric.code) !== -1 && parametric?.value?.length > 0;
        }
        return parametric.value?.length > 0 && parametric.code === code;
    };

    return parametrics.find(findParametric) || variantParametrics.find(findParametric);
};

const isVariantProduct = (product) => (product.variants || []).length > 0;

class ProductPageContainer extends Component {
    static propTypes = {
        loading: PropTypes.func,
        location: PropTypes.object.isRequired,
        page: PropTypes.object.isRequired,
        render: PropTypes.func.isRequired,
        shouldFetchRelations: PropTypes.bool,
    };

    static defaultProps = {
        loading: null,
        shouldFetchRelations: true,
    };

    state = this.resetState(this.props.page?.data?.product);

    componentDidMount() {
        this.getProductRelations();
        this.getQtyBreaks();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (JSON.stringify(nextState) !== JSON.stringify(this.state)) {
            return true;
        }

        const product = this.state.product || {};
        const nextProduct = nextProps?.page?.data?.product || {};
        const productVariants = nextProduct?.variants || [];

        return (
            (getExternalId(nextProduct) !== getExternalId(product) &&
                (!productVariants.length || getExternalId(productVariants[0]) !== getExternalId(product))) ||
            (nextProduct.price !== product.price &&
                (!productVariants.length || productVariants[0].price !== product.price)) ||
            (nextProduct.priceListId !== product.priceListId &&
                (!productVariants.length || productVariants[0].priceListId !== product.priceListId))
        );
    }

    componentWillUnmount() {
        const { current } = getState('overlay');
        if (current === 'gallery_zoom_overlay') {
            hideOverlays();
        }
    }

    resetState(product) {
        const newState = { ...initialState };
        if (!product) {
            return newState;
        }

        const currentPathname = !inServer ? window.location.pathname : this.props.location.pathname;

        // Match current URL pathname against variant slugs
        const matchedVariant = product.variants.find((v) => v.slug === currentPathname);

        const isVariant = isVariantProduct(product);

        const { variants } = product;

        const selectedProductVariants = {};
        if (!isVariant && (product.includedProducts || []).length) {
            product.includedProducts.forEach((subProduct) => {
                if ((subProduct.variants || []).length > 1) {
                    selectedProductVariants[getExternalId(subProduct)] = null;
                } else {
                    selectedProductVariants[getExternalId(subProduct)] = subProduct;
                }
            });
        } else if (isVariant && matchedVariant) {
            selectedProductVariants[getExternalId(product)] = matchedVariant;
        } else if (isVariant) {
            // No match found, default to first variant
            const [firstVariant] = variants;
            selectedProductVariants[getExternalId(product)] = firstVariant;
        } else {
            selectedProductVariants[getExternalId(product)] = product;
        }

        const selectedVariant = selectedProductVariants[getExternalId(product)] || {};

        const { bestHistoricalPriceIncVat } = product;
        const bestHistoricalPrice = bestHistoricalPriceIncVat / product.vatRate;

        const selectedProduct = this.getSelectedProductData(selectedVariant, product, variants);

        return {
            ...newState,
            bestHistoricalPrice,
            product,
            quantity: product.recommendedQuantity ? product.recommendedQuantity : 1,
            selectedProduct,
            selectedProductVariants,
            variants,
        };
    }

    getSelectedProductData(selectedVariant, product) {
        if (!inServer) {
            const variantSlug = selectedVariant?.slug;
            if (variantSlug && window.location.pathname !== variantSlug) {
                window.history.replaceState(null, null, variantSlug);
            }
        }

        const selectedProduct = Object.keys(selectedVariant || {}).length ? selectedVariant : product;

        const selectedProductParametrics = (selectedProduct.includedProducts || [])
                .map((p) => ({ name: p.name, parametrics: p.parametrics || [] }))
                .filter((p) => p.parametrics.length);
        const parametrics = JSON.parse(JSON.stringify(selectedProductParametrics || []));

        (product.parametrics || []).forEach(
            (parametric) =>
                parametrics.every((addedParametric) => addedParametric.code !== parametric.code) &&
                parametrics.push(parametric),
        );
        const variantParametrics = (selectedProduct.includedProducts || [])
                .map((p) => ({ name: p.name, variantParametrics: p.variantParametrics || [] }))
                .filter((p) => p.variantParametrics.length);

        const format = selectedVariant.format || product.format || {};
        return {
            catalogPriceExVat: selectedProduct.priceCatalog || product.priceCatalog,
            categories: selectedVariant.categories || product.categories || [],
            description: selectedVariant.description || product.description,
            descriptionHeader: selectedVariant.descriptionHeader || product.descriptionHeader,
            eanCode: selectedVariant.eanCode || product.eanCode,
            files: selectedProduct.files,
            flags: selectedVariant?.format?.flags || product?.format?.flags || [],
            format,
            id: getExternalId(selectedVariant),
            image: format?.image,
            imageKey: selectedProduct.imageKey,
            includedProducts: selectedProduct.includedProducts,
            manufacturer: selectedVariant.manufacturer || product.manufacturer,
            manufacturerPartNo: selectedProduct.manufacturer?.partNo || product.manufacturer?.partNo,
            name: selectedVariant.variantName || product.name,
            onHand: selectedVariant.onHand || product.onHand,
            onHandStore: selectedVariant.onHandStore || product.onHandStore,
            parametrics,
            partNo: getExternalId(selectedProduct),
            priceExVat: selectedProduct.price || product.price,
            priceListCode: selectedProduct.priceListCode,
            priceListId: selectedProduct.priceListId,
            quantity: selectedProduct.quantity,
            recommendedPriceExVat: selectedProduct.priceRecommended || product.priceRecommended,
            standardPriceExVat: selectedProduct.priceStandard || product.priceStandard,
            type: selectedProduct.type,
            uom: selectedProduct.uom,
            variantParametrics,
            vatRate: selectedProduct.vatRate || product.vatRate,
        };
    }

    getProductRelations = async () => {
        const productId = this.state.product && getExternalId(this.state.product);

        if (productId && this.props.shouldFetchRelations) {
            try {
                const response = await GetProductRelations(productId, { asVariants: true });
                const productPageRelations = response?.data.find(({ code }) => code === PRODUCTPAGERELATIONS);
                const productRelations = productPageRelations?.relations?.items || [];
                const variantRelations = productPageRelations?.variantRelations || [];

                const mappedVariantRelations = variantRelations.reduce((allRelations, relation) => {
                    const relations = relation?.relations?.items || [];

                    const mappedVariants = relations.reduce((products, product) => {
                        let firstParentMatch = products.length
                            ? products.find((p) => p.oldVariants.some((v) => getExternalId(v) === getExternalId(product)))
                            : null;
                        const variant = product.variants.find((v) => getExternalId(v) === getExternalId(product));

                        if (firstParentMatch) {
                            products = products.map((p) => {
                                if (getExternalId(p) === getExternalId(firstParentMatch)) {
                                    p.variants.push(variant);
                                }

                                return p;
                            });
                        } else {
                            firstParentMatch = product;
                            firstParentMatch.oldVariants = firstParentMatch.variants;
                            firstParentMatch.variants = [variant];

                            products.push(firstParentMatch);
                        }

                        return products;
                    }, []);

                    if (getExternalId(relation)) {
                        allRelations[getExternalId(relation)] = mappedVariants;
                    }

                    return allRelations;
                }, {});

                if (productRelations?.length || !isEmpty(mappedVariantRelations)) {
                    this.setState({
                        productRelations,
                        variantRelations: mappedVariantRelations,
                    });
                }
            } catch (e) {
                console.error(e);
            }
        }
    };

    // TODO: Implement quantity breaks functionality when API supports it
    getQtyBreaks = () => {
        // Stub method - quantity breaks not available in current API
    };

    // TODO: Implement upsells functionality when API supports it
    setUpsells = () => {
        // Stub method - upsells not available in current API
    };

    // TODO: Implement quantity change functionality when needed
    setQuantity = (quantity) => {
        this.setState({ quantity });
    };

    returnLowestPrice = (currentPrice, newPrice) =>
        !currentPrice || currentPrice > newPrice ? newPrice : currentPrice;

    getPricingOfProducts = (products) => {
        const { product: mainProduct, selectedProductVariants, quantity = 1 } = this.state;

        let lowestMainProductPrice;
        if (mainProduct.variants?.length > 1) {
            lowestMainProductPrice = mainProduct.variants.reduce(
                (minPrice, variant) => {
                    const priceExVat = this.returnLowestPrice(minPrice.priceExVat, variant.price || 0);
                    const variantHasLowestPrice = minPrice.priceExVat === null || minPrice.priceExVat > priceExVat;
                    let { standardPriceExVat } = minPrice;
                    let { priceListId } = minPrice;
                    if (variantHasLowestPrice) {
                        standardPriceExVat = variant.priceStandard;
                        priceListId = variant.priceListId;
                    }
                    return {
                        priceListId,
                        priceExVat,
                        standardPriceExVat,
                    };
                },
                {
                    priceListId: mainProduct.priceListId,
                    priceExVat: null,
                    standardPriceExVat: null,
                },
            );
        }
        const price = products.reduce(
            (price, product) => {
                if (product) {
                    // We place a fallback to quantity "1" if it does not exist.
                    const productQuantity = product.quantity || 1;
                    const { includedProducts } = product;
                    let { priceListId } = product;
                    let productPrice = product.priceExVat || product.price || 0;
                    let productStandardPriceExVat =
                        comparePriceToParent(includedProducts) ||
                        product.standardPriceExVat ||
                        product.priceStandard ||
                        0;
                    const productVatRate = product.vatRate;

                    if (
                        (mainProduct.variants || []).some((v) => getExternalId(v) === getExternalId(product)) &&
                        !selectedProductVariants[getExternalId(mainProduct)]
                    ) {
                        priceListId = lowestMainProductPrice.priceListId;
                        productPrice = lowestMainProductPrice.priceExVat;
                        productStandardPriceExVat = lowestMainProductPrice.standardPriceExVat;
                    }

                    return {
                        ...price,
                        priceListId,
                        priceExVat: price.priceExVat + productPrice * productQuantity,
                        priceIncVat: price.priceIncVat + productPrice * productVatRate * productQuantity,
                        standardPriceExVat: price.standardPriceExVat + productStandardPriceExVat * productQuantity,
                    };
                }

                return price;
            },
            {
                priceListId: null,
                priceIncVat: 0,
                priceExVat: 0,
                standardPriceExVat: 0,
                quantityOfPackage: quantity > 0 ? quantity : 1,
            },
        );

        price.vatRate = price.priceIncVat / price.priceExVat || mainProduct?.vatRate || 1;

        return price;
    };


    // -- -------- CALLBACKS


    setVariant = (pId, pVariant) => {
        // Ge t the current selectedProductVariants from the state (as a new object)
        const selectedVariants = { ...this.state.selectedProductVariants };

        // If the productId is not the same as the new productVariant we update the state
        if (selectedVariants[pId] !== pVariant) {
            if (pVariant === undefined) {
                delete selectedVariants[pId];
            } else {
                selectedVariants[pId] = pVariant;
            }

            const newState = { selectedProductVariants: selectedVariants };

            // if new productVariant is set, update selectedProduct
            if (this.state.product && pId === getExternalId(this.state.product)) {
                newState.selectedProduct = this.getSelectedProductData(
                    pVariant || {},
                    this.state.product,
                    this.state.variants,
                );
            }

            this.setState(newState);
        }
    };

    render() {
        const {
            bestHistoricalPrice,
            isPackage,
            product,
            qtyBreaks,
            quantity,
            selectedProduct,
            selectedProductVariants,
            productRelations,
            variantRelations,
            variants,
        } = this.state;

        let relations = productRelations;
        if (selectedProduct && variantRelations[selectedProduct?.id || getExternalId(selectedProduct)]) {
            relations = relations.concat(variantRelations[selectedProduct.id || getExternalId(selectedProduct)]);
        }

        const { loading: Loading, page, render: Render } = this.props;
        const isQuantityPackage = isVariantProduct(product || {}) && selectedProduct.isPackage;

        if (!product && Loading) {
            return <Loading />;
        }

        let totalPricing = {};

        if (isPackage) {
            totalPricing = this.getPricingOfProducts([selectedProduct]);
        } else if (!selectedProductVariants[getExternalId(product)]) {
            totalPricing = this.getPricingOfProducts([selectedProduct]);
        } else {
            totalPricing = this.getPricingOfProducts([...Object.values(selectedProductVariants)]);
        }


        return (
            <>
                <ProductMeta product={product} />
                <Render
                    bestHistoricalPrice={bestHistoricalPrice}
                    isVariant={isVariantProduct(product)}
                    pageData={{
                        localeAlternates: page.localeAlternates,
                        defaultName: page.data?.product?.defaultName || page.data?.product?.name,
                        defaultUniqueUrlName: page.data?.product?.defaultUniqueUrlName || page.data?.product?.slug,
                        id: page.data?.product?.id || getExternalId(page.data?.product),
                        partNo: page.data?.product?.partNo || getExternalId(page.data?.product),
                        variantPartNos: page.data?.product?.variantPartNos || page.data?.product?.variants?.map(v => getExternalId(v)),
                    }}
                    product={product}
                    qtyBreaks={qtyBreaks}
                    quantity={quantity}
                    isQuantityPackage={isQuantityPackage}
                    selectedProduct={selectedProduct}
                    selectedProductVariants={selectedProductVariants}
                    variants={variants?.length ? variants : product.variants}
                    totalPricing={totalPricing}
                    relations={relations}
                    onQuantityChange={this.setQuantity}
                    onUpsellChange={this.setUpsells}
                    onVariantChange={this.setVariant}
                />
            </>
        );
    }
}

export default withRouter(injectModels(['page', 'application'])(ProductPageContainer));
